import styled, { css } from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { CssFlex } from "styles/helpers/layout";

export const StyledTabContainer = styled(CssFlex)<Props>`
  height: 3rem;
  align-items: flex-start;

  :after {
    content: '.';
    color: transparent;
    padding: 0.5rem 1.5rem;
    flex-grow: 1;
    border-bottom: 2px solid ${(props: Props) => props.theme.palette.neutral._900};
  }
`;

interface StyledTabProps extends Props {
  $isActive?: boolean;
}

export const StyledTab = styled(CssFlex)<StyledTabProps>`
  column-gap: 0.5rem;
  align-items: center;
  padding: 0.5rem 1.5rem;

  border-bottom: 2px solid ${(props: StyledTabProps) => props.theme.palette.neutral._900};

  ${(props: StyledTabProps) =>
    props.$isActive &&
    css`
    color: ${(props: StyledTabProps) => props.theme.palette.primary.brand};
    border-color: ${(props: StyledTabProps) => props.theme.palette.primary.brand};
  `}

  :hover {
    cursor: pointer;
    color: ${(props: StyledTabProps) => props.theme.palette.primary._400};
    border-color: ${(props: StyledTabProps) => props.theme.palette.primary._400};
    border-width: 5px;
  }
`;
